export enum StatusNotes {
  PRICE = 1,
  PROPERTY_CATEGORY = 2,
  AREA = 3,
  AREA_SIZE = 4,
  PROPERTY_DESCRIPTION = 5,
  OTHER = 6,
}

export const StatusNotesLabels: Record<StatusNotes, string> = {
  [StatusNotes.PRICE]: 'السعر',
  [StatusNotes.PROPERTY_CATEGORY]: 'فئة العقار',
  [StatusNotes.AREA]: 'المنطقة',
  [StatusNotes.AREA_SIZE]: 'مساحة',
  [StatusNotes.PROPERTY_DESCRIPTION]: 'وصف العقار',
  [StatusNotes.OTHER]: 'غير ذلك',
};

export const StatusNotesMap = Object.entries(StatusNotesLabels).reduce(
  (acc, [key, label]) => {
    const numericKey = Number(key);
    if (!isNaN(numericKey)) {
      acc[label] = numericKey;
    }
    return acc;
  },
  {} as Record<string, number>
);
